import Footer from '../features/footer/footer';
import Header from '../features/headers/header';
import NotFound from '../features/errors/layouts/not-found';
import { MAIN_CONTENT_ID } from '../global/config/layout';

export default function NotFoundPage() {
    return (
        <>
            <Header />
            <main id={MAIN_CONTENT_ID} className="app-shell__main" tabIndex={-1}>
                <NotFound />
            </main>
            <Footer />
        </>
    );
}
